module.exports = __webpack_public_path__ + "img/hardwareOpen1.871834c7.png";